// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"0":"4e5a1b9a689c1c20e238","159":"e33e7f10a099379186e4","685":"3a1cec3632733fad7220","766":"aba125ac056f35f2f43c"}[chunkId] + ".chunk.js";
};